
import { executeSearchStrategy } from "./search/SearchOrchestrator";

export const useSearchManager = () => {
  const handleSearch = async (
    query: string,
    setSearchResults: (results: any[]) => void,
    setCurrentQuery: (query: string) => void,
    setCurrentView: (view: string) => void,
    setLoading: (loading: boolean) => void
  ) => {
    setLoading(true);
    setCurrentView("search");
    setCurrentQuery(query);

    try {
      await executeSearchStrategy(query, setSearchResults);
    } catch (error: any) {
      console.error('Search error:', error);
    } finally {
      setLoading(false);
    }
  };

  return {
    handleSearch
  };
};
